import Component from '../core/Component';
import $ from 'jquery';
import flickity from 'flickity';
import { queries } from '../core/config';
import enquire from 'enquire.js';

export default class ContactSlider extends Component
{
    constructor($element)
    {
        super($element);
        this.$doc = $(document);
        this.desktop = false;
    }

    prepare(){

        enquire.register(queries.smallWideUp, {
            match: () => {
                this.desktop = true;
            }
        });

        if (this.desktop){
            this.groupCells = 2;
        }
        else{
            this.groupCells = false;
        }

        const slider = new flickity( this.element, {
            wrapAround: true,
            groupCells: this.groupCells,
            prevNextButtons: this.desktop,
            resize: true,
            lazyLoad: true,
        });
    }

}


// WEBPACK FOOTER //
// ./components/ContractSlider.js